/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BarChartData
 */
export interface BarChartData {
    /**
     * 
     * @type {Array<string>}
     * @memberof BarChartData
     */
    barTitles: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BarChartData
     */
    barValues: Array<string>;
}

/**
 * Check if a given object implements the BarChartData interface.
 */
export function instanceOfBarChartData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "barTitles" in value;
    isInstance = isInstance && "barValues" in value;

    return isInstance;
}

export function BarChartDataFromJSON(json: any): BarChartData {
    return BarChartDataFromJSONTyped(json, false);
}

export function BarChartDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BarChartData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'barTitles': json['barTitles'],
        'barValues': json['barValues'],
    };
}

export function BarChartDataToJSON(value?: BarChartData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'barTitles': value.barTitles,
        'barValues': value.barValues,
    };
}

